import React from 'react';
import { LegalPageLayout, LegalSection } from '../components/LegalPageLayout';

const TOC = [
  { id: 'what', label: 'What Are Cookies' },
  { id: 'types', label: 'Cookies We Use' },
  { id: 'thirdparty', label: 'Third-Party Cookies' },
  { id: 'widgets', label: 'Embedded Booking Widgets' },
  { id: 'control', label: 'How to Control Cookies' },
  { id: 'dnt', label: 'Do Not Track' },
  { id: 'changes', label: 'Changes & Contact' },
];

const CookiePolicy = () => (
  <LegalPageLayout title="Cookie Policy" lastUpdated="August 5, 2026" toc={TOC}>
    <LegalSection id="what" number={1} title="What Are Cookies">
      <p>
        Cookies are small text files stored on your device by your browser. We also use similar
        technologies such as local storage and pixels. Together, these help the platform stay signed in,
        remember preferences, keep bookings secure, and understand how the product is used so we can
        improve it. This policy supplements the cookies section of our <a href="/privacy">Privacy Policy</a>.
      </p>
    </LegalSection>

    <LegalSection id="types" number={2} title="Cookies We Use">
      <ul>
        <li><strong>Strictly necessary</strong> — authentication sessions, security tokens, and fraud prevention. The platform cannot function without these; they cannot be switched off.</li>
        <li><strong>Preferences</strong> — remembering settings like your dashboard layout, selected organization, and language/display choices.</li>
        <li><strong>Analytics</strong> — product analytics that show us how features are used (pages visited, clicks, session replays with sensitive fields masked) so we can improve the platform. See the subprocessors list in our <a href="/privacy">Privacy Policy</a>.</li>
        <li><strong>Payments</strong> — our payment processor (Stripe) sets cookies for checkout security and fraud detection when you make or take a payment.</li>
      </ul>
    </LegalSection>

    <LegalSection id="thirdparty" number={3} title="Third-Party Cookies">
      <p>
        Some cookies are set by third parties acting on our behalf — for example, our payment processor
        and analytics providers. These parties are bound by their own privacy policies and by our
        agreements with them. We do not sell data collected via cookies, and we do not run third-party
        advertising cookies on the operator dashboard.
      </p>
    </LegalSection>

    <LegalSection id="widgets" number={4} title="Embedded Booking Widgets">
      <p>
        When an Operator embeds a BookingFlows booking widget on their own website, the widget uses only
        the cookies and storage necessary to complete a booking (session continuity, checkout security).
        The Operator&apos;s own website may set additional cookies governed by that Operator&apos;s cookie policy.
      </p>
    </LegalSection>

    <LegalSection id="control" number={5} title="How to Control Cookies">
      <ul>
        <li>Most browsers let you block or delete cookies in settings — note that blocking strictly necessary cookies will break sign-in and checkout;</li>
        <li>You can clear local storage per-site through your browser&apos;s developer or privacy tools;</li>
        <li>Where required by law (e.g. for EU visitors), analytics cookies are used consistent with applicable consent requirements.</li>
      </ul>
    </LegalSection>

    <LegalSection id="dnt" number={6} title="Do Not Track">
      <p>
        Some browsers offer a &ldquo;Do Not Track&rdquo; signal. There is no common industry standard for
        responding to these signals, so the platform does not currently change behavior in response to
        them. We will update this policy if that changes.
      </p>
    </LegalSection>

    <LegalSection id="changes" number={7} title="Changes & Contact">
      <p>
        We may update this policy as our use of cookies evolves; the effective date above reflects the
        latest revision. Questions? Reach us through our <a href="/support#tickets">Support Center</a>.
      </p>
    </LegalSection>
  </LegalPageLayout>
);

export default CookiePolicy;
